import {
  fileCertificate, gear, home, IconDefinition, moneyCheckDollar, arrowRightFromBracket, fileCheck, circleSterling, store
} from '@simplybusiness/icons';

/*
* urlDestination' distinguishes between internal (React router) and external (full page reload) navigation
*  NavContent uses this to decide between navigate() and window.location.href.
*/
export type NavLink = {
  label: string;
  trackingLabel?: string;
  icon: IconDefinition;
  href: string;
  urlDestination?: 'internal' | 'external';
};

export const resolveTrackingLabel = (link: NavLink): string =>
  link.trackingLabel ?? link.label.toLowerCase().replace(/ /g, '_');

export const usPageLinks: NavLink[] = [
  {
    label: 'Home',
    icon: home,
    href: '/',
    urlDestination: 'internal',
  },
  {
    label: 'Certificates',
    icon: fileCertificate,
    href: '/certificate-of-insurance',
    urlDestination: 'internal',
  },
  {
    label: 'Billing & Payments',
    icon: moneyCheckDollar,
    href: '/payment-details',
    urlDestination: 'internal',
  },
  {
    label: 'Explore Coverages',
    trackingLabel: 'explore_all_products',
    icon: store,
    href: '/explore-all-products',
    urlDestination: 'internal',
  },
];

export const ukPageLinks: NavLink[] = [
  {
    label: 'Home',
    icon: home,
    href: '/',
    urlDestination: 'internal',
  },
  {
    label: 'Payment details',
    icon: circleSterling,
    href: '/payment-details',
    urlDestination: 'internal',
  },
  {
    label: 'Claims',
    icon: fileCheck,
    href: 'https://www.simplybusiness.co.uk/insurance-claims/',
    urlDestination: 'external',
  },
];

export const appLinks: NavLink[] = [
  {
    label: 'My details',
    icon: gear,
    href: '/account-details',
    urlDestination: 'internal',
  },
  {
    label: 'Logout',
    icon: arrowRightFromBracket,
    href: 'logout',
  },
];
